<template>
  <div class="top-500">
    <div class="title">
      <span>{{ tabList[tabIndex].name }}</span>
      <ElementSelect :val="yearE" v-model="yearE" :options="eYearList"></ElementSelect>
    </div>
    <div class="chart-con">
      <TabList :list="tabList" :act="tabIndex" @clickItem="changeTab" @changeSelect="changeSelect" />
      <div class="table-list has-tab">
        <div
                class="table-item"
                v-for="(item, i) in dataList"
                :key="i"
                @mouseenter="showTooltip(item, $event)"
                @mouseleave="hideTooltip"
        >
          <div class="left-con">
            <div :class="['num', 'top' + item.top, { top: item.top < 4 }]">{{ item.top }}</div>
            <div class="name">{{ item.name }}</div>
          </div>
          <div class="affiliation">{{ item.affiliation }}</div>
        </div>
      </div>
    </div>

    <!-- 悬浮提示框 -->
    <div
            v-if="showTooltipFlag && currentTooltipItem"
            class="tooltip-box"
            :style="tooltipStyle"
    >
      <div class="tooltip-content">
        <div class="tooltip-title">企业信息</div>
        <div class="tooltip-row">
          <span class="tooltip-label">排名：</span>
          <span class="tooltip-value">{{ currentTooltipItem.top }}</span>
        </div>
        <div class="tooltip-row">
          <span class="tooltip-label">企业名称：</span>
          <span class="tooltip-value">{{ currentTooltipItem.name }}</span>
        </div>
        <div class="tooltip-row">
          <span class="tooltip-label">所属地区：</span>
          <span class="tooltip-value">{{ currentTooltipItem.affiliation }}</span>
        </div>
        <div class="tooltip-row" v-if="currentTooltipItem.businessIncome">
          <span class="tooltip-label">营业收入(万元)：</span>
          <span class="tooltip-value">{{ formatTotalNum(currentTooltipItem.businessIncome) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ElementSelect from '../../../components/element-select';
  import TabList from '../../../components/tabList';
  import { getTop500Data } from '@/api/getTableData';
  import $ from 'jquery';

  export default {
    name: 'Top500',
    components: { TabList, ElementSelect },
    props: {
      yearP: {
        type: Number,
        default: 2023,
      },
      selectListP: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        yearE: 0,
        eYearList: [],
        eYearOption: [],
        selectId: this.yearP,
        selectList: [...this.selectListP],
        tabIndex: 0,
        tabList: [
          {
            value: 'World',
            label: '世界',
            name: '世界500强',
          },
          {
            value: 'National',
            label: '全国',
            name: '中国民营企业500强',
            select: true,
            selectId: '全国',
            options: [
              {
                value: '全国',
                label: '全国',
              },
              {
                value: '广东省',
                label: '广东省',
              },
            ],
          },
          {
            value: 'Manufacturing',
            label: '制造业',
            name: '中国制造业民营企业500强',
          },
          {
            value: 'ServiceIndustry',
            label: '服务业',
            name: '中国服务业民营企业100强',
          },
        ],
        dataList: [],
        listBox: null,
        scrollY: 0,
        timer: null,

        // 悬浮提示相关数据
        showTooltipFlag: false,
        currentTooltipItem: null,
        tooltipStyle: {
          top: '0px',
          left: '0px',
        },
      };
    },
    created() {
      this.initYear();
    },
    watch: {
      tabIndex(n) {
        this.selectId = this.yearP;
        this.initYear();
      },
      yearE(n) {
        this.getData();
        if (this.tabIndex === 1) {
          this.tabList[1].selectId = '全国';
        }
      },
    },
    methods: {
      initYear() {
        let table = 'tj_world_top_500';
        if (this.tabIndex === 0) {
          table = 'tj_world_top_500';
        }
        if (this.tabIndex === 1) {
          table = 'tj_country_top_500_private_enterprises';
        }
        if (this.tabIndex === 2) {
          table = 'tj_country_top_500_manufacturers';
        }
        if (this.tabIndex === 3) {
          table = 'tj_country_top_100_service_industry';
        }

        this.$api.market.getTyYearOption({dataType: table}).then((res) => {
          this.eYearOption = res.data.data.data;
          if (this.yearE === 0) {
            this.yearE = this.eYearOption[0];
            this.eYearList = []
            for (let key in this.eYearOption) {
              this.eYearList.push({
                value: this.eYearOption[key],
                lable: this.eYearOption[key],
              });
            }
          }
        });
      },

      // 显示悬浮提示
      showTooltip(item, event) {
        this.currentTooltipItem = item;
        this.showTooltipFlag = true;

        // 计算提示框位置
        this.$nextTick(() => {
          const tooltip = this.$el.querySelector('.tooltip-box');
          if (tooltip) {
            const tooltipWidth = tooltip.offsetWidth;
            const tooltipHeight = tooltip.offsetHeight;
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            // 默认位置：鼠标右下方
            let left = mouseX + 10;
            let top = mouseY + 10;

            // 如果右侧空间不足，显示在左侧
            if (left + tooltipWidth > viewportWidth - 20) {
              left = mouseX - tooltipWidth - 10;
            }

            // 如果底部空间不足，显示在上方
            if (top + tooltipHeight > viewportHeight - 20) {
              top = mouseY - tooltipHeight - 10;
            }

            // 确保不超出左侧边界
            if (left < 10) {
              left = 10;
            }

            // 确保不超出顶部边界
            if (top < 10) {
              top = 10;
            }

            this.tooltipStyle = {
              top: top + 'px',
              left: left + 'px',
            };
          }
        });
      },

      // 隐藏悬浮提示
      hideTooltip() {
        this.showTooltipFlag = false;
        this.currentTooltipItem = null;
      },

      // 格式化数字显示
      formatTotalNum(num) {
        if (!num && num !== 0) return '-';

        // 如果是数字，格式化为带逗号的千分位
        if (typeof num === 'number') {
          return num.toLocaleString('zh-CN') + ' 万元';
        }

        // 如果是字符串，尝试转换为数字
        const number = parseFloat(num);
        if (!isNaN(number)) {
          return number.toLocaleString('zh-CN') + ' 万元';
        }

        return num;
      },

      changeTab(item, i) {
        this.clear();
        this.hideTooltip(); // 切换tab时隐藏tooltip
        if (i === 1) {
          item.selectId = item.options[0].value;
        }
        this.selectList = [...this.selectListP];
        this.tabIndex = i;
        this.getData();
      },

      changeSelect(data, i) {
        this.clear();
        this.hideTooltip(); // 切换选择时隐藏tooltip
        this.scrollY = 0;
        this.tabIndex = i;
        this.scrollList();
        if (data.selectId === '全国') {
          this.getData();
        } else {
          this.dataList = this.dataList.filter((item) => item.affiliation === data.selectId);
          this.scrollY = 0;
          this.scrollList();
        }
      },

      getData() {
        this.$api.screen
                .getEnterpriseRanking({
                  type: this.tabIndex,
                  year: this.yearE,
                })
                .then(async (res) => {
                  let { data } = res.data;
                  if (data?.length) {
                    this.dataList = await data[0].rankings.map((item) => {
                      return {
                        ...item,
                        top: item.ranking,
                        year: item.year,
                        name: item.enterpriseName,
                        affiliation: item.comeFrom,
                        businessIncome: item.businessIncome || item.revenue || item.income, // 兼容不同字段名
                      };
                    });
                    this.scrollY = 0;
                    await this.scrollList();
                  }
                });
      },

      scrollList() {
        let time = 0;
        let isBottom = false;
        if (this.timer) {
          this.clear();
        }
        if (this.scrollY && this.scrollY === this.listBox.scrollHeight) {
          isBottom = true;
          this.scrollY = this.listBox.scrollHeight;
        } else if (this.scrollY < this.listBox.scrollHeight) {
          isBottom = false;
        }
        let height = isBottom ? this.scrollY - this.listBox.scrollTop : this.scrollY - this.listBox.clientHeight;
        if (isBottom && this.listBox.scrollTop) {
          let top = this.listBox.scrollTop;
          let reTime = top && String(top).length > 4 ? 0.5 : 1;
          // for (let i = top; i >= 0; i--) {
          //   setTimeout(() => {
          //     this.listBox.scrollTo(0, i);
          //   }, (top - i) * reTime)
          // }
          // setTimeout(() => {
          this.scrollY = 0;
          this.scrollList();
          // }, 5000)
        } else {
          for (let i = height; i < this.scrollY; i++) {
            time++;
            setTimeout(() => {
              this.listBox.scrollTo(0, i);
            }, time * 10);
          }
        }
        if (!isBottom) {
          this.scrollY =
            this.scrollY < this.listBox.scrollHeight ? this.scrollY + this.listBox.clientHeight : this.scrollY;
          this.scrollY =
            this.scrollY > this.listBox.scrollHeight
              ? this.listBox.scrollHeight
              : this.scrollY === this.listBox.scrollHeight
              ? 0
              : this.scrollY;

          this.timer = setTimeout(() => {
            this.scrollList();
          }, time + 8000);
        }
      },

      clear() {
        clearTimeout(this.timer);
        this.timer = null;
      },
    },

    mounted() {
      this.getData();

      this.$nextTick(() => {
        let listBox = $('.top-500 .table-list');
        this.listBox = listBox[0];
      });
    },
  };
</script>


<style lang="less" scoped>
  .top-500 {
    .chart-box();

    /deep/.tab-list {
      .tab-item {
        min-width: 74px !important;
      }
    }

    /deep/.table-list {
      transition: all 0.5s;

      .table-item {
        padding: 0 30px 0 20px;
        width: 100%;

        > div {
          &.left-con {
            max-width: calc(100% - 105px);
          }

          .name {
            max-width: calc(100% - 30px);
            .ellipsis();
          }

          &.affiliation {
            /*min-width: 60px;*/
            min-width: auto;
            max-width: 100px;
            text-align: right;
            letter-spacing: 6px;
            .ellipsis();
            /*word-break: keep-all;*/
          }
        }
      }
    }
  }

  /* 悬浮提示框样式 */
  .tooltip-box {
    position: fixed;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 6px;
    padding: 12px 16px;
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
    min-width: 220px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.1);
    pointer-events: none;
    animation: fadeIn 0.2s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .tooltip-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .tooltip-title {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .tooltip-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .tooltip-label {
    color: rgba(255, 255, 255, 0.7);
    min-width: 60px;
    margin-right: 8px;
  }

  .tooltip-value {
    color: #fff;
    text-align: right;
    flex: 1;
    word-break: break-word;
  }

  /* 箭头样式（可选） */
  .tooltip-box::before {
    content: '';
    position: absolute;
    top: -5px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid rgba(0, 0, 0, 0.85);
  }

  /* 表格行添加悬停效果 */
  .table-item {
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .table-item:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
</style>


